import App from './App.svelte';

const app = new App({
  target: document.getElementById('root'),
  props: {
    doc: '18C0Q3VRUOnQBtbOhUlGwkKIKrD-Icf4HFrDY3L4M_RU',
  },
});

export default app;
